/**
 * easingFunctions.js
 * Created by Destin Frasier 03/06/18
 * Based on https://github.com/fedspendingtransparency/usaspending-website/blob/dev/src/js/helpers/animation/easingFunctions.js
 */

export const easeInOutQuad = (time, start, end, duration) => {
    const change = end - start;

    const progress = (time / (duration / 2));
    if (progress < 1) {
        return ((change / 2) * progress * progress) + start;
    }

    return ((-change / 2) * (((progress - 1) * (progress - 3)) - 1)) + start;
};

// t = current time
// b = start value
// c = change in value
// d = duration
export const animatedEaseInOutQuad = (t, b, c, d) => {
    let time = t;
    time /= d / 2;
    if (time < 1) {
        return c / 2 * time * time + b;
    }
    time -= 1;
    return -c / 2 * (time * (time - 2) - 1) + b;
};
